import React from 'react';
import StyledText from 'components/Helpers/StyledText/StyledText';

const Bildtext = props => {
  const style = require('./Bildtext.scss');
  var { text, foto, credit} = props;
  return (
      (text || foto || credit) &&
      <figcaption className={style.caption}>
        {text && <StyledText className={style.captionText}>{text}</StyledText>}
        {foto && <StyledText className={style.captionCredit}>{" Foto: " + foto}</StyledText>}
        {credit && <StyledText className={style.captionCredit}>{" " + credit}</StyledText>}
      </figcaption> || <noscript/>
  );
};

export default Bildtext;



/** WEBPACK FOOTER **
 ** ./~/eslint-loader!./src/components/Helpers/Bildtext/Bildtext.js
 **/